import { actionTypes } from './actions';

const initialState = {
  formType: localStorage.getItem('formType') || '',
  currentStep: 0,
  formData: localStorage.getItem('formData') ? JSON.parse(localStorage.getItem('formData')) : {},
  authenticated: true,
  sessionId:localStorage.getItem('session_id') || null,
};

function formReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_FORM_TYPE:
      localStorage.setItem('formType', action.payload);
      return { ...state, formType: action.payload, currentStep: 0, formData: {}, submitted: false };
    case actionTypes.SET_FORM_DATA:
      const newFormData = { ...state.formData, [action.payload.key]: action.payload.value };
      return { ...state, formData: newFormData };
    case actionTypes.NEXT_STEP:
      return { ...state, currentStep: state.currentStep + 1 };
    case actionTypes.PREVIOUS_STEP:
      return { ...state, currentStep: state.currentStep - 1 };
    case actionTypes.RESET_FORM:
      localStorage.removeItem('formData');
      localStorage.removeItem('formType');
      return { ...initialState };

    case actionTypes.SET_SESSION_ID:
      localStorage.setItem('session_id',action.payload)
      return {...state,sessionId:action.payload}
      
    case actionTypes.SET_APPLICATION_ID:
      localStorage.setItem('application_id',action.payload)
      return {...state,applicationId:action.payload}

    case actionTypes.SET_CRM_LEAD_ID:
      return {...state,crmLeadId:action.payload}
    case 'LOGIN':
      return { ...state, authenticated: true };
    case 'LOGOUT':
      return { ...state, authenticated: false };
    default:
      return state;
  }
}

export default formReducer;
